<template>
  <div>
    <div v-if="loading" class="d-flex justify-content-center align-items-center vh-100">
      <Spinner spinner-class="mb-1" />
    </div>
    <div v-else class="container-fluid py-4">
      <div v-if="stores.length > 0">
        <div class="header-section mb-4">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <vue-feather class="nav me-3 navigation-icon" type="arrow-left-circle" @click="$router.go(-1)" stroke="#000000" size="35" stroke-width="1.5"></vue-feather>
              <h3 class="mb-0 fw-bold">Store Selection</h3>
            </div>
            <vue-feather class="nav navigation-icon" type="log-out" @click="logout" stroke="#fc0303" size="35" stroke-width="1.5"></vue-feather>
          </div>
          <p class="text-muted mt-2">Select a store to continue with your operations</p>
          <div class="divider my-3"></div>
        </div>

        <div class="row g-4">
          <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-12" v-for="store in stores" :key="store.id">
            <Card body-classes="p-0" class="store-card h-100">
              <template v-slot:header>
                <div class="d-flex align-items-center justify-content-between p-1">
                  <h5 class="mb-0 fw-bold">{{store.name}}</h5>
                  <span :class="`badge rounded-pill store-badge ${store.type === 'main' ? 'main-store' : 'branch-store'}`">
                    {{ store.type }}
                  </span>
                </div>
              </template>
              <div class="store-card-body p-3">
                <div class="store-info mb-3">
                  <div class="d-flex align-items-center mb-2">
                    <vue-feather type="hash" size="16" class="me-2 text-muted"></vue-feather>
                    <span>{{ store.code }}</span>
                  </div>
                  <div class="d-flex align-items-center">
                    <vue-feather type="map-pin" size="16" class="me-2 text-muted"></vue-feather>
                    <span>{{ store.address }}</span>
                  </div>
                </div>
                <div class="store-action mt-4">
                  <button
                    v-if="!checkActiveStore(store.id)"
                    class="btn btn-select w-100"
                    @click="selectStore(store)">
                    <vue-feather type="check-circle" size="16" class="me-2"></vue-feather>
                    Select Store
                  </button>
                  <button
                    v-else
                    class="btn btn-current w-100"
                    disabled>
                    <vue-feather type="check" size="16" class="me-2"></vue-feather>
                    Current Store
                  </button>
                </div>
              </div>
            </Card>
          </div>
          <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-12">
            <Card body-classes="p-0" class="store-card h-100" style="background-color: #f8f8f8">
              <div class="p-3">
                <div class="store-info mb-3">
                  <div class="text-center mb-2">
                    <i class="bi bi-shop fs-1 text-muted"></i>
                    <h3 class="mt-3 fw-bold">Add New Store</h3>
                  </div>
                </div>
                <div class="store-action mt-3">
                  <button
                      class="btn btn-outline-dark mt-3 w-100"
                      @click="selectStore(stores[0], true)">
                    <vue-feather type="plus" size="16" class="me-2"></vue-feather>
                    Add Store
                  </button>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>

      <div v-else class="row d-flex align-items-center justify-content-center">
        <div class="col-xxl-6 col-xl-8 col-md-10">
          <Card body-classes="p-0" class="register-card bg-white">
            <template v-slot:header>
              <div class="p-3">
                <h4 class="mb-0 fw-bold">Register New Store</h4>
                <p class="text-muted mb-0 mt-1">Create your first store to get started</p>
              </div>
            </template>
            <div class="p-4">
              <form @submit.prevent="">
                <div class="row g-4">
                  <div class="form-group col-md-6">
                    <label for="code" class="form-label fw-bold mb-2">Store Code</label>
                    <div class="input-group">
                      <span class="input-group-text"><vue-feather type="hash" size="16"></vue-feather></span>
                      <input type="text" class="form-control" placeholder="Code" v-model="store.code" readonly>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="name" class="form-label fw-bold mb-2">Branch Name</label>
                    <div class="input-group">
                      <span class="input-group-text"><vue-feather type="tag" size="16"></vue-feather></span>
                      <input type="text" class="form-control" placeholder="Branch Name" v-model="store.name">
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="address" class="form-label fw-bold mb-2">Address</label>
                    <div class="input-group">
                      <span class="input-group-text"><vue-feather type="map-pin" size="16"></vue-feather></span>
                      <input type="text" class="form-control" placeholder="Address" v-model="store.address">
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="phone" class="form-label fw-bold mb-2">Phone</label>
                    <div class="input-group">
                      <span class="input-group-text"><vue-feather type="phone" size="16"></vue-feather></span>
                      <input type="text" class="form-control" placeholder="Phone" v-model="store.phone">
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="p-4 d-flex justify-content-end">
              <button class="btn btn-outline-secondary me-3" @click="$router.go(-1)">
                <vue-feather type="arrow-left" size="16" class="me-2"></vue-feather>
                Back
              </button>
              <button v-if="profile.role !== 'user'" class="btn btn-primary" @click="submitForm">
                <vue-feather type="save" size="16" class="me-2"></vue-feather>
                Save Store
              </button>
            </div>
          </Card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import storeService from "@/api/storeService";
import formatDate from "../../utils/formatDate";
import {decrypt, encrypt} from "@/utils/crypto";
import notify from "@/utils/notify";
import authService from "@/api/authService";

export default {
  name: "SelectStore",

  data(){
    this.organization = JSON.parse(decrypt(sessionStorage.getItem('organization')))
    return {
      organization: {},
      profile: {},
      loading: true,
      stores: [],
      store: {
        organization_id: this.organization.id,
        type: 'main',
        online: 0,
      },
    }
  },

  methods: {
    formatDate,
    getStores: async function () {
      this.stores = await storeService.getStores()
      if (this.stores.length === 0) {
        let nextNo = await storeService.getStoreNextNo()
        this.store.code = nextNo.next
      }
      this.loading = false
    },
    async submitForm() {
      let response = await storeService.createStore(this.store)
      if (response) {
        window.location.reload()
      }
    },
    selectStore(store, add = false) {
      sessionStorage.setItem('store', encrypt(JSON.stringify(store)))
      notify.alert.success('Switched to ' + store.name + ' successfully')
      if (add) {
        this.$router.push('/stores')
      } else {
        this.$router.push('/dashboard')
      }
    },
    checkActiveStore(storeId) {
      let storeData = sessionStorage.getItem('store')
      if (storeData !== null) {
        let store = JSON.parse(decrypt(storeData))
        if (store.id === storeId) {
          return true
        }
      }
    },
    async logout() {
      await authService.userLogout()
    }
  },

  created: async function () {
    this.profile = JSON.parse(decrypt(sessionStorage.getItem('profile')))
    await this.getStores()
  },

}
</script>

<style scoped>
.nav:hover {
  cursor: pointer;
  opacity: 0.7;
  transform: scale(1.05);
}

.navigation-icon {
  transition: all 0.2s ease;
}

.divider {
  height: 1px;
  background: linear-gradient(to right, rgba(0,123,255,0.1), rgba(0,123,255,0.5), rgba(0,123,255,0.1));
}

.store-card {
  border-radius: 10px;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  overflow: hidden;
}

.store-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.store-card .card-header {
  background-color: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 15px;
}

.store-card-body {
  background-color: #ffffff;
}

.store-badge {
  font-size: 0.7rem;
  padding: 0.35em 0.8em;
  font-weight: 600;
  text-transform: uppercase;
}

.main-store {
  background-color: rgba(25, 135, 84, 0.1);
  color: #198754;
}

.branch-store {
  background-color: rgba(13, 110, 253, 0.1);
  color: #0d6efd;
}

.store-info {
  color: #6c757d;
  font-size: 0.9rem;
}

.btn-select {
  background-color: #0d6efd;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.btn-select:hover {
  background-color: #0b5ed7;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(13, 110, 253, 0.2);
}

.btn-current {
  background-color: #f8f9fa;
  color: #6c757d;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 10px;
  font-weight: 500;
}

.register-card {
  border-radius: 10px;
  border: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.register-card .card-header {
  background-color: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.input-group {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.02);
  border-radius: 6px;
  overflow: hidden;
}

.input-group-text {
  background-color: #f8f9fa;
  border-color: #dee2e6;
  color: #6c757d;
}

.form-control {
  border-color: #dee2e6;
  padding: 10px 15px;
}

.form-control:focus {
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.15);
}
</style>
